import gql from 'graphql-tag';

export default gql`
    mutation DietSetReplaceProductMutation(
        $request: UserDietSetReplaceProductInputType
    ) {
        me {
            dietSetReplaceProduct(request: $request) {
                __typename
                ... on UnauthorizedException {
                    code
                }
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
                ... on BasicMutationSuccess {
                    code
                }
            }
        }
    }
`;
